module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAUCAYAAAC58NwRAAAAAXNSR0IArs4c6QAAAK9JREFUOE+V070NwjAQhuH3AhINBY0TOhiBUdghA4RRQs8OjADbIJyChi6FkS0IiuK/uLrie3T22RZmLvnltWJddrxT3oHXhl2/4g605ZNzDDmgK2qBi60NnGLov6WKRqBNoQF8OyXRCOSgCUghL4ihIAihKLCoK7kiHG29NBziHRSNFONRh8/gCdsu/ikFwl6gI+EJSIVHICc8AK2opZjxWh9b9gvDLfs/uFvN/HEfMrFZSRMQObEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grade/study-right.png
// module id = 0e1S
// module chunks = 1